module.exports = __webpack_public_path__ + "static/Notice-052ff85989cb0bb77d806f15f77ea215.png";